import { render, staticRenderFns } from "./OngoingSeries.vue?vue&type=template&id=6dfe7294&"
import script from "./OngoingSeries.vue?vue&type=script&lang=js&"
export * from "./OngoingSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports